/* eslint-disable react/no-unescaped-entities */
import career1 from "@/assets/images/career-1.png";
import career2 from "@/assets/images/career-2.png";
import Layout from "@/components/elements/Layout";
import { getCareerList } from "@/services/api/Career";
import { getSEOByPathname } from "@/services/api/SEO";
import slugify from "@/utils/slugify";
import Image from "next/legacy/image";
import Link from "next/link";

const Careers = ({ careers, seoData }) => {
  return (
    <Layout seoData={seoData}>
      <div className='relative overflow-hidden'>
        <div className='right-0 transform translate-x-[60%] translate-y-[15%] top-[15%] shape'></div>
        <div className='relative max-w-6xl px-4 pt-20 pb-16 mx-auto lg:pb-32 lg:pt-40 2xl:max-w-7xl'>
          <div className='absolute aspect-[851/986] h-[200px] lg:h-[600px] top-0 right-0 lg:left-0 lg:-translate-x-1/2 -translate-y-1/2 -z-10'>
            <Image
              src='/images/lucidity.svg'
              width={851}
              height={986}
              alt='lucidity logo'
            />
          </div>
          <h1 className='leading-tight tracking-tight text-[44px] font-bold text-white lg:pl-32 lg:text-7xl'>
            Careers at <br /> Lucidity Insights
          </h1>
          <div className='mt-12 space-y-16 lg:space-y-32 lg:mt-24'>
            <div className='items-center grid-cols-12 gap-20 lg:grid'>
              <div className='col-span-6'>
                <Image src={career1} width={800} height={800} alt='' />
              </div>
              <div className='col-span-5 mt-12 text-white lg:mt-0'>
                <h2 className='text-3xl font-bold'>
                  Welcome to Lucidity Insights' Careers Page
                </h2>
                <p className='mt-5 opacity-50'>
                  where we showcase opportunities to join our team of passionate
                  professionals who are dedicated to covering the dynamic
                  startup and venture ecosystem of the MENA region. As a leading
                  source of news, analysis, and data on the region's
                  entrepreneurial landscape, we are committed to fostering
                  innovation and growth in the Middle East and we believe that
                  our people are our most valuable asset and we strive to create
                  an environment that empowers our team members to grow both
                  personally and professionally. It also means that we hire the
                  best person for the role - no matter where you are based. We
                  have team members across Europe, the Middle East and in Asia,
                  and in 2023 - we believe remote work is here to stay.
                </p>
              </div>
            </div>
            <div className='items-center grid-cols-12 gap-20 lg:grid'>
              <div className='col-span-6'>
                <Image src={career2} width={800} height={800} alt='' />
              </div>
              <div className='order-first col-span-5 col-start-2 mt-12 text-white lg:mt-0'>
                <h2 className='text-3xl font-bold'>
                  If you're looking to join a team of individuals who are
                  passionate about the intersection of business, technology, and
                  society - we'd love to hear from you
                </h2>
                <p className='mt-5 opacity-50'>
                  Our current openings span a range of disciplines from
                  editorial and research to marketing and product development.
                  As a member of our team, you'll have the opportunity to make
                  an impact in a fast-paced, collaborative environment - that
                  sticks to strict deadlines - and gets the job done. If you
                  find a role that suits your skill set - we'd love to hear from
                  you.
                  <br />
                  <br />
                  We can't respond to everyone that applies, so we apologize for
                  that in advance. Do note that your CVs are stored in our
                  system - so if you do apply, don't apply again until your CV
                  is updated with new experiences.
                </p>
              </div>
            </div>
            <div>
              <div className='flex items-center space-x-4'>
                <span className='flex-1 border-t border-white/10'></span>
                <h2 className='text-2xl font-bold text-white lg:text-4xl'>
                  Opening Positions
                </h2>
                <span className='flex-1 border-t border-white/10'></span>
              </div>
              <div className='mt-8 space-x-8 lg:mt-12 lg:flex'>
                {careers.map((career) => (
                  <Link legacyBehavior
                    key={career.uuid}
                    href={`/careers/${slugify(career.job_title)}-${career.id}`}
                  >
                    <a className='flex-1'>
                      <div className='relative aspect-video'>
                        <Image
                          src={career.thumbnail_url}
                          width={1600}
                          height={900}
                          alt=''
                          className='object-cover'
                        />
                        <span className='absolute inset-0 w-full h-full bg-black/50'></span>
                        <div className='absolute inset-0 z-10 flex items-center justify-center w-full h-full text-center'>
                          <div className='flex flex-col space-y-1 text-white lg:space-y-2'>
                            <span className='text-xl font-bold lg:text-3xl'>
                              {career.job_title}
                            </span>
                            <span className='text-sm opacity-60'>
                              {career.employee_type} &bull;{" "}
                              {career.workplace_type}
                            </span>
                          </div>
                        </div>
                      </div>
                    </a>
                  </Link>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default Careers;

export async function getServerSideProps() {
  let seoData = {};
  try {
    const seoResponse = await getSEOByPathname('careers');
    seoData = seoResponse.data;
  } catch (error) {
    console.error("Error fetching SEO data:", error);
  }

  const careerData = await getCareerList({
    params: {
      is_open: 1,
    },
  });
  const careers = careerData?.data || [];

  return {
    props: {
      careers,
      seoData
    },
  };
}
